import type { ViewConfigKpiPivot } from '@salescore/core'
import { useRecoilState } from 'recoil'

import { configAtom } from '../../viewConfig'

export const useViewConfigKpiPivot = (): [ViewConfigKpiPivot | undefined, (kpiConfig: ViewConfigKpiPivot) => void] => {
  const [config, setConfig] = useRecoilState(configAtom)
  if (config.type !== 'kpiPivot') {
    // 本当はuseViewConfigKpiにならってErrorにしたい。
    // ここでthrowすると、KPIからダッシュボードのプレビューを開く動線で
    // ContextMenuの表示切り替えが上手く対応できないため、一旦undefinedのreturnにしておく。
    return [undefined, setConfig]
  }

  return [
    config,
    (kpiConfig: ViewConfigKpiPivot): void => {
      setConfig(kpiConfig)
    },
  ]
}
